// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__fOVYe","content":"styles_content___EYfS","linkWrapper":"styles_linkWrapper__ifZ0K","icon":"styles_icon__LV5eh","image":"styles_image__0dp3c"};